<script setup lang="ts">
import { useStorage } from '@vueuse/core'
import type { GCDComicDisplay, RandomGCDDisplayResponse } from '~/types/gcd'

const cv = useStorage('resume', '/resume')
const role = useStorage('role', 'Full Stack Software Developer')

// Fake comic data for resume page
const resumeComic: Partial<GCDComicDisplay> = {
  api_url: 'qUCTdx',
  editing: 'I have built and implemented dozens of scalable web applications for IBM’s internal teams and client-facing solutions including Watson Health and WebSphere Portal. I have deployed new technologies, including AI, to drive automation, optimize performance, and improve efficiency.',
  indicia_publisher: '',
  series_name: role.value,
  cover: '/images/resume-card.jpg',
  link: cv.value,
  linkText: 'Résumé/CV',
  attribution: false,
  forceShow: true,
  number: '42',
  page_count: '42',
  publication_date: '10191 AG',
  price: '42 ₩',
}
const { status: gcdStatus, data: gcdComics } = useFetch<RandomGCDDisplayResponse>('/api/randomGCD', {
  key: 'random-gcd',
  lazy: true,
  server: true,
  immediate: true,
  watch: false,
})
const loading = computed(() => gcdStatus.value === 'pending')
const error = computed(() => gcdStatus.value === 'error')
const success = computed(() => gcdStatus.value === 'success')

const comics = computed(() => {
  try {
    // console.log('gcdComics', success.value, error.value, gcdComics.value)
    if (success.value) {
      const list = [...(gcdComics.value as GCDComicDisplay[])]
      list.push(resumeComic as GCDComicDisplay)
      return list
    }
    else if (error.value) return [{}, {}, {}, resumeComic]
    return Array(4)
  }
  catch (err: unknown) {
    console.warn('error getting gcd comics array', (err as Error)?.message)
    return [resumeComic]
  }
})

const show = ref(false)
const currentComic = ref<GCDComicDisplay | null>(null)

function showInfo(comic: GCDComicDisplay) {
  currentComic.value = comic
  show.value = true
}

const safeCards = computed(() => (comics.value ?? []).slice(0, 4))
</script>

<template>
  <div class="h-screen w-screen bg-[url('@/assets/images/comic-background-b.jpg')] bg-cover">
    <LandingGcdInfo
      :show="show"
      :comic="currentComic"
      @hide-info="show=false"
    />
    <!-- Bottom-docked grid, 16px from bottom -->
    <div class="fixed inset-x-0 bottom-4 z-50 px-4">
      <div
        class="mx-auto grid w-full max-w-[80%] grid-cols-2 grid-rows-2 gap-4 md:grid-cols-4 md:grid-rows-1"
      >
        <LandingGcdCard
          v-for="comic in safeCards"
          :key="comic?.api_url"
          :comic="comic"
          :loading="loading"
          :error="error"
          :success="success"
          @show-info="showInfo(comic)"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="css">
</style>
